import { Resource, Resources } from 'constants/resources';
import { FINANCE_ROLES, Role } from 'constants/roles';

import { useFlag } from '@unleash/proxy-client-react';
import { usePermissions } from 'hooks/usePermissions';
import { MENU_LIST } from 'layouts/components/Menu/constants/menuList';
import { filterMenuList } from 'layouts/components/Menu/utils/filterMenuList';

export const useMenuList = () => {
  const { roles, hasResourceAccess, isHaveRole } = usePermissions();
  const isOrderManualCreateEnabled = useFlag('wppa_12335_order_manual_create');

  const visibility: Partial<Record<Resource, boolean>> = {
    [Resources.Commissions]: roles?.some((role) =>
      [...FINANCE_ROLES, Role.Admin, Role.Tech].includes(role),
    ),
    [Resources.OrderManualCreate]: isOrderManualCreateEnabled && isHaveRole([Role.Admin]),
    [Resources.Companies]: hasResourceAccess(Resources.Companies),
    [Resources.Referrals]: hasResourceAccess(Resources.Companies),
  };

  const menuList = filterMenuList(MENU_LIST, (resource) => visibility[resource] ?? true);

  return { menuList };
};
